import { Base } from '@or-sdk/base';
import { SERVICE_KEY } from './constants';
export class SdkApi extends Base {
    constructor(params) {
        const { token, discoveryUrl, accountId, sdkUrl } = params;
        super({
            token,
            discoveryUrl,
            serviceKey: SERVICE_KEY,
            accountId,
            serviceUrl: sdkUrl,
        });
    }
    makeRequest(params) {
        return this.callApi(params);
    }
    normalizeRoute(route) {
        if (route.startsWith('/')) {
            return route.substring(1);
        }
        return route;
    }
}
//# sourceMappingURL=SdkApi.js.map